import { SUMMARY_ROW_ID, createAllRangeDates, getFromMapByTimestamp, mapCurrentDataToTimestampsMap, negative, } from '@fourthwall/module-analytics';
const calculateOtherCosts = (totalCosts, breakdownItems) => {
    const breakdownSum = Number(breakdownItems.reduce((sum, item) => sum + item, 0).toFixed(2));
    return totalCosts - breakdownSum > 0 ? totalCosts - breakdownSum : 0;
};
export const createChartStatsTableProfit = (current, params) => {
    if (!current)
        return [];
    const allRangeDates = createAllRangeDates(params).reverse();
    const grossSales = mapCurrentDataToTimestampsMap(current.grossSales?.data);
    const discounts = mapCurrentDataToTimestampsMap(current.discounts?.data);
    const costs = mapCurrentDataToTimestampsMap(current.cost?.data);
    // costs breakdown
    const productCosts = mapCurrentDataToTimestampsMap(current.itemsCost?.data);
    const fulfillmentFeesCosts = mapCurrentDataToTimestampsMap(current.fulfillmentFeeCost?.data);
    const shippingCosts = mapCurrentDataToTimestampsMap(current.shippingCost?.data);
    const taxesCosts = mapCurrentDataToTimestampsMap(current.taxCost?.data);
    const paymentFeesCosts = mapCurrentDataToTimestampsMap(current.paymentFeeCost?.data);
    const membershipsFeesCosts = mapCurrentDataToTimestampsMap(current.costMembership?.data);
    const inventoryStorageCosts = mapCurrentDataToTimestampsMap(current.costInventoryStorage?.data);
    const manualChargesCosts = mapCurrentDataToTimestampsMap(current.costAIT?.data);
    const cancellations = mapCurrentDataToTimestampsMap(current.cancellations?.data);
    const refunds = mapCurrentDataToTimestampsMap(current.refunds?.data);
    const profits = mapCurrentDataToTimestampsMap(current.profit?.data);
    const statsTableData = allRangeDates.map((date) => {
        const totalCosts = getFromMapByTimestamp(costs, date) || 0;
        const otherCosts = calculateOtherCosts(totalCosts, [
            getFromMapByTimestamp(productCosts, date) || 0,
            getFromMapByTimestamp(fulfillmentFeesCosts, date) || 0,
            getFromMapByTimestamp(shippingCosts, date) || 0,
            getFromMapByTimestamp(taxesCosts, date) || 0,
            getFromMapByTimestamp(paymentFeesCosts, date) || 0,
            getFromMapByTimestamp(membershipsFeesCosts, date) || 0,
            getFromMapByTimestamp(inventoryStorageCosts, date) || 0,
            getFromMapByTimestamp(manualChargesCosts, date) || 0,
        ]);
        return {
            id: date,
            day: date,
            grossSales: getFromMapByTimestamp(grossSales, date) || 0,
            discounts: negative(getFromMapByTimestamp(discounts, date)) || 0,
            cost: negative(getFromMapByTimestamp(costs, date)) || 0,
            // costs breakdown
            productCosts: negative(getFromMapByTimestamp(productCosts, date)) || 0,
            fulfillmentFeesCosts: negative(getFromMapByTimestamp(fulfillmentFeesCosts, date)) || 0,
            shippingCosts: negative(getFromMapByTimestamp(shippingCosts, date)) || 0,
            taxesCosts: negative(getFromMapByTimestamp(taxesCosts, date)) || 0,
            paymentFeesCosts: negative(getFromMapByTimestamp(paymentFeesCosts, date)) || 0,
            membershipsFeesCosts: negative(getFromMapByTimestamp(membershipsFeesCosts, date)) || 0,
            inventoryStorageCosts: negative(getFromMapByTimestamp(inventoryStorageCosts, date)) || 0,
            manualChargesCosts: negative(getFromMapByTimestamp(manualChargesCosts, date)) || 0,
            otherCosts: negative(otherCosts) || 0,
            cancellations: negative(getFromMapByTimestamp(cancellations, date)) || 0,
            refunds: negative(getFromMapByTimestamp(refunds, date)) || 0,
            profit: getFromMapByTimestamp(profits, date) || 0,
        };
    });
    // Calculate summary row breakdown
    const summaryTotalCosts = current.cost?.aggregatedValue || 0;
    const summaryOtherCosts = calculateOtherCosts(summaryTotalCosts, [
        current.itemsCost?.aggregatedValue || 0,
        current.fulfillmentFeeCost?.aggregatedValue || 0,
        current.shippingCost?.aggregatedValue || 0,
        current.taxCost?.aggregatedValue || 0,
        current.paymentFeeCost?.aggregatedValue || 0,
        current.costMembership?.aggregatedValue || 0,
        current.costInventoryStorage?.aggregatedValue || 0,
        current.costAIT?.aggregatedValue || 0,
    ]);
    statsTableData.unshift({
        id: SUMMARY_ROW_ID,
        day: 'Summary',
        grossSales: current.grossSales?.aggregatedValue || 0,
        discounts: negative(current.discounts?.aggregatedValue) || 0,
        cost: negative(current.cost?.aggregatedValue) || 0,
        // costs breakdown
        productCosts: negative(current.itemsCost?.aggregatedValue) || 0,
        fulfillmentFeesCosts: negative(current.fulfillmentFeeCost?.aggregatedValue) || 0,
        shippingCosts: negative(current.shippingCost?.aggregatedValue) || 0,
        taxesCosts: negative(current.taxCost?.aggregatedValue) || 0,
        paymentFeesCosts: negative(current.paymentFeeCost?.aggregatedValue) || 0,
        membershipsFeesCosts: negative(current.costMembership?.aggregatedValue) || 0,
        inventoryStorageCosts: negative(current.costInventoryStorage?.aggregatedValue) || 0,
        manualChargesCosts: negative(current.costAIT?.aggregatedValue) || 0,
        otherCosts: negative(summaryOtherCosts) || 0,
        cancellations: negative(current.cancellations?.aggregatedValue) || 0,
        refunds: negative(current.refunds?.aggregatedValue) || 0,
        profit: current.profit?.aggregatedValue || 0,
    });
    return statsTableData;
};
